import React from 'react';
import './ComponentsCss/BackgroundFooter.css';


 
 
const BackgroundFooter = () => {
  return (
<>



<footer className="footer">
        <p className='footertextbottom'>© 2026 <a href="https://srql.com" id='Rights'>https://srql.com</a>. All rights reserved.
       
        </p>

      
       
        
      </footer>
</>
  );
};
 
export default BackgroundFooter;